import React from 'react';
import { Grid, TextField } from '@mui/material';
import { useFormikContext } from 'formik';
import Autocomplete from '@/components/_common/Form/Autocomplete';
import { Detail } from '@/__configs/config_types';
import { FormValues } from '@/redux/slices/slice_types';

interface Props {
  addlFields: string[];
  customFields: Record<string, Detail>;
}

const OPAdditionalOrderFields: React.FC<Props> = ({ addlFields, customFields }) => {
  const { values, setFieldValue, touched, handleChange, errors } = useFormikContext<FormValues>();

  return addlFields.map((fieldKey) => {
    const fieldConfig = customFields[fieldKey];

    if (!fieldConfig) {
      return null;
    }

    return (
      <Grid key={fieldKey} item xs={12} sm={6} md={5} lg={3}>
        {fieldConfig.type === 'autocomplete' ? (
          <Autocomplete
            id={fieldKey}
            label={fieldConfig.label}
            data-testid={`${fieldKey}-select`}
            fullWidth={false}
            options={fieldConfig.options || []}
            value={values[fieldKey]}
            required={fieldConfig.required}
            onChange={(e, val) => setFieldValue(fieldKey, val)}
          />
        ) : (
          <TextField
            label={fieldConfig.label}
            name={fieldKey}
            value={values[fieldKey]}
            variant="filled"
            onChange={handleChange}
            fullWidth
            required={fieldConfig.required}
            error={touched[fieldKey] && Boolean(errors[fieldKey])}
            autoComplete="off"
          />
        )}
      </Grid>
    );
  });
};

export default OPAdditionalOrderFields;